import styled from "@emotion/styled";
import { FC } from "react";

import { DesignToken } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

const Container = styled.div`
  position: relative;
  padding: 48px 20px;
`;

const Heading = styled.h3`
  font-size: 14px;
  font-weight: 400;
  text-align: center;
  color: ${withVar(DesignToken.ContentBasicSecondary)};
`;

interface IProps {
  title?: React.ReactNode;
}

export const SearchNoMatches: FC<IProps> = ({ title = "No matches found." }) => (
  <Container>
    <Heading>{title}</Heading>
  </Container>
);
